<div class="mijn-tokens-browser">
    <mijn-login-template [title]="getTitle() | apContent" [showExtraContentCard]="false">
        <div header>
            @if (!takeoverError) {
                @if (showNotification) {
                    <ap-notification data-bb="notification" status="success" [closeable]="true" (closeClicked)="onCloseNotification()">
                        {{ 'mijn.tokens.browser.notificationText' | apContent }}
                    </ap-notification>
                }
            }
        </div>

        @if (takeoverError) {
            @if (isBrowserError()) {
                <tokens-browser-error [apError]="takeoverError" (action)="onErrorAction($event)"> </tokens-browser-error>
            }
            @if (!isBrowserError()) {
                <ap-error [apError]="takeoverError"> </ap-error>
            }
        }
        @if (!takeoverError) {
            <router-outlet></router-outlet>
        }
    </mijn-login-template>
</div>
